export default __webpack_public_path__ + "static/media/reason_insights.f8793539.svg";